import { groupDictId } from "./ConfigurationTranslators.helpers";
export function createConfigurationAttributeGroupTranslators(options, variables) {
    const { translator, translations } = options;
    return {
        name(attributeGroupId) {
            const baseDictId = groupDictId(attributeGroupId);
            const dictId = `${baseDictId}.name`;
            const fallback = attributeGroupId;
            return translator(dictId, fallback, Object.assign(Object.assign({}, translations), { variables, returnObjects: false }));
        },
        description(attributeGroupId) {
            const baseDictId = groupDictId(attributeGroupId);
            const dictId = `${baseDictId}.description`;
            const fallback = attributeGroupId;
            return translator(dictId, fallback, Object.assign(Object.assign({}, translations), { variables, returnObjects: false }));
        },
    };
}
//# sourceMappingURL=createConfigurationAttributeGroupTranslators.js.map